var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBaseMethodology = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "320px",
    height: "296px",
    viewBox: "0 0 320 296",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "document")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Demo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.1.-Index-Builder---Create-New-Index---Paths---00",
    transform: "translate(-1071.000000, -433.000000)",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 1.20231214
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(185.000000, 373.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(606.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document",
    transform: "translate(281.156069, 23.121387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.8898271,0 C61.9409321,0 45.708457,15.4512726 45.708457,34.371526 L44.3930636,212.581121 L64.1283,212.716763 L65.4443128,34.4411317 C65.4443128,25.9034291 72.8220349,18.9583283 81.8904464,18.9583283 L280.231214,18.9583283 L280.231214,0 L81.8898271,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.526532,0 C259.780896,0 242.902775,16.899113 242.902775,37.6719374 L242.902775,246.849246 C242.902775,261.970782 230.612355,274.27694 215.510159,274.27694 C200.407962,274.27694 188.117543,261.970782 188.117543,246.849246 L188.117543,222.725966 C188.117543,217.250133 183.685188,212.812102 178.216358,212.812102 L9.90118497,212.812102 C4.43235549,212.812102 0,217.250133 0,222.725966 L0,246.849246 C0,272.905649 21.1712861,294.104046 47.1943642,294.104046 L47.1943642,274.27694 C32.0890607,274.27694 19.8017486,261.970782 19.8017486,246.849246 L19.8017486,232.639208 L168.315795,232.639208 L168.315795,246.848624 C168.315795,272.905026 189.487081,294.104046 215.510159,294.104046 C241.533237,294.104046 262.704523,272.905026 262.704523,246.848624 L262.704523,91.8659448 L308.249104,91.8659448 C313.717934,91.8659448 318.150289,87.4279134 318.150289,81.9520806 L318.150289,37.6713152 C318.150289,16.899113 301.272789,0 280.526532,0 Z M298.34854,72.0388386 L262.705145,72.0388386 L262.705145,37.6713152 C262.705145,27.8302464 270.701777,19.8271062 280.526532,19.8271062 C290.351286,19.8271062 298.347919,27.8308686 298.347919,37.6713152 L298.347919,72.0388386 L298.34854,72.0388386 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 47.1676301,
    y: 274.682081,
    width: 165.549133,
    height: 19.4219653
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.417521,55.4913295 L96.7443292,55.4913295 C91.3270176,55.4913295 86.9364162,59.8385392 86.9364162,65.2023121 C86.9364162,70.5660851 91.3270176,74.9132948 96.7443292,74.9132948 L147.417521,74.9132948 C152.834832,74.9132948 157.225434,70.5660851 157.225434,65.2023121 C157.225434,59.8385392 152.834217,55.4913295 147.417521,55.4913295 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.511816,95.2601156 L95.9159297,95.2601156 C90.4453415,95.2601156 86.0115607,99.6073253 86.0115607,104.971098 C86.0115607,110.334871 90.4453415,114.682081 95.9159297,114.682081 L206.511816,114.682081 C211.982404,114.682081 216.416185,110.334871 216.416185,104.971098 C216.416185,99.6073253 211.982404,95.2601156 206.511816,95.2601156 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.511816,134.104046 L95.9159297,134.104046 C90.4453415,134.104046 86.0115607,138.451256 86.0115607,143.815029 C86.0115607,149.178802 90.4453415,153.526012 95.9159297,153.526012 L206.511816,153.526012 C211.982404,153.526012 216.416185,149.181849 216.416185,143.815029 C216.416185,138.451256 211.982404,134.104046 206.511816,134.104046 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.511816,174.797688 L95.9159297,174.797688 C90.4453415,174.797688 86.0115607,179.144898 86.0115607,184.508671 C86.0115607,189.872443 90.4453415,194.219653 95.9159297,194.219653 L206.511816,194.219653 C211.982404,194.219653 216.416185,189.872443 216.416185,184.508671 C216.416185,179.144898 211.982404,174.797688 206.511816,174.797688 Z",
    id: "Path"
  })))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBaseMethodology, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Base_Methodology.8325e2d7.svg";
export { ForwardRef as ReactComponent };